export default __webpack_public_path__ + "static/media/bloggerly.8a8b2674.svg";